export const tableExpand = (() => {
    const tables = document.querySelectorAll('.content-editorial table:not([class]):not(table table)');
    if (!tables.length) return;

    const EXPAND_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const CLOSE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    tables.forEach((table, index) => {
        const dialogId = `table-fullscreen-dialog-${index}`;

        // Build inline wrapper: .table-wrapper > .table-scroll > table
        const wrapper = document.createElement('div');
        wrapper.classList.add('table-wrapper');

        const scrollContainer = document.createElement('div');
        scrollContainer.classList.add('table-scroll');

        table.parentNode.insertBefore(wrapper, table);
        scrollContainer.appendChild(table);
        wrapper.appendChild(scrollContainer);

        // Expand button — absolute positioned outside scroll container
        const expandBtn = document.createElement('button');
        expandBtn.type = 'button';
        expandBtn.classList.add('table-expand-btn');
        expandBtn.setAttribute('aria-label', 'Visa tabell i helskärm');
        expandBtn.setAttribute('aria-controls', dialogId);
        expandBtn.innerHTML = `${EXPAND_SVG} Helskärm`;
        wrapper.appendChild(expandBtn);

        // Only show the expand button — and the scrollbar strip below the table —
        // when the table overflows horizontally (i.e. there's a horizontal scrollbar).
        const updateOverflowState = () => {
            const hasOverflow = scrollContainer.scrollWidth - scrollContainer.clientWidth > 1;
            expandBtn.hidden = !hasOverflow;
            scrollContainer.classList.toggle('has-overflow', hasOverflow);
        };

        updateOverflowState();

        // Re-evaluate on resize (responsive layout changes, late web-font reflow).
        if ('ResizeObserver' in window) {
            new ResizeObserver(updateOverflowState).observe(scrollContainer);
        } else {
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(updateOverflowState, 150);
            });
        }

        // Build fullscreen dialog
        const dialog = document.createElement('dialog');
        dialog.classList.add('table-fullscreen-dialog');
        dialog.id = dialogId;

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.classList.add('table-fullscreen-close');
        closeBtn.setAttribute('aria-label', 'Stäng helskärmsvy');
        closeBtn.innerHTML = CLOSE_SVG;

        const fullscreenScroll = document.createElement('div');
        fullscreenScroll.classList.add('table-fullscreen-scroll');
        fullscreenScroll.appendChild(table.cloneNode(true));

        dialog.appendChild(closeBtn);
        dialog.appendChild(fullscreenScroll);
        document.body.appendChild(dialog);

        // Event handlers
        let previousFocus;
        let scrollPosition = 0;

        const openDialog = () => {
            previousFocus = document.activeElement;
            // Save scroll position BEFORE opening dialog
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            document.body.classList.add('table-dialog-open');
            dialog.showModal();

            // Restore scroll position immediately
            window.scrollTo(0, scrollPosition);
        };

        expandBtn.addEventListener('click', openDialog);
        closeBtn.addEventListener('click', () => dialog.close());

        // Backdrop click closes dialog
        dialog.addEventListener('click', (e) => {
            if (e.target === dialog) dialog.close();
        });

        // Centralise focus restore on any close (ESC, button, backdrop)
        dialog.addEventListener('close', () => {
            document.body.classList.remove('table-dialog-open');
            if (previousFocus) previousFocus.focus({ preventScroll: true });
            // Restore scroll position on close
            window.scrollTo(0, scrollPosition);
        });
    });
})();
